"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fadePrev = exports.fadeNext = void 0;

var fadeNext = function fadeNext(carousel, speed) {
  carousel.current.firstChild.classList.add("fade-in");
  carousel.current.insertBefore(carousel.current.firstChild, carousel.current.lastChild.nextSibling);
  setTimeout(function () {
    carousel.current.children[carousel.current.children.length - 1].classList.remove("fade-in");
  }, speed);
};

exports.fadeNext = fadeNext;

var fadePrev = function fadePrev(carousel, speed) {
  carousel.current.lastChild.classList.add("fade-out");
  setTimeout(function () {
    carousel.current.lastChild.classList.remove("fade-out");
    carousel.current.insertBefore(carousel.current.lastChild, carousel.current.firstChild);
  }, speed);
};

exports.fadePrev = fadePrev;